import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import * as VueGoogleMaps from 'vue2-google-maps';
import DatetimePicker from '../index';
Vue.use(Vuetify);
Vue.use(DatetimePicker);

const opts = {
  libraries: 'drawing'
};
if (process.env.VUE_APP_MAP_CLIENT) {
  opts.client = process.env.VUE_APP_MAP_CLIENT;
}

Vue.use(VueGoogleMaps, {
  load: opts
});

export default new Vuetify({
  icons: {
    iconfont: 'mdi',
  },
});
